import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

const TabPanel = ({ children, value, index, idPrefix = 'tab', ...other }) => (
  <div
    role='tabpanel'
    hidden={value !== index}
    id={`${idPrefix}-tabpanel-${index}`}
    aria-labelledby={`${idPrefix}-tab-${index}`}
    {...other}
  >
    {value === index && <Box>{children}</Box>}
  </div>
)

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  idPrefix: PropTypes.string
}

export default TabPanel
